export default __webpack_public_path__ + "static/media/fridge.0a541275.svg";